import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19437d3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "px-2",
  style: {"max-height":"calc(100vh - 3rem)","overflow-y":"auto","overflow-x":"hidden"}
}
const _hoisted_2 = {
  key: 0,
  class: "text-muted fs-7 p-3"
}
const _hoisted_3 = { class: "qd-sticky-top pb-3 border-bottom border-gray-200" }
const _hoisted_4 = { class: "d-flex align-items-start justify-content-between" }
const _hoisted_5 = { class: "pe-3" }
const _hoisted_6 = {
  class: "fs-4 umt-drawer-title text-gray-900",
  style: {"font-weight":"700"}
}
const _hoisted_7 = {
  key: 0,
  class: "text-muted fs-7"
}
const _hoisted_8 = { class: "fw-semibold text-gray-700" }
const _hoisted_9 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex flex-wrap gap-2 mt-2"
}
const _hoisted_11 = {
  key: 2,
  class: "badge badge-light-success"
}
const _hoisted_12 = {
  key: 3,
  class: "badge badge-light-info"
}
const _hoisted_13 = {
  key: 0,
  class: "d-flex align-items-start bg-light-danger border border-danger border-dashed rounded px-3 py-2 mt-4"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-octagon-fill text-danger me-2" }, null, -1))
const _hoisted_15 = { class: "fs-8 text-gray-800" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder" }, "Cảnh báo tốt nghiệp:", -1))
const _hoisted_17 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4 mt-4" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary mb-3" }, "Thông tin cơ bản", -1))
const _hoisted_19 = { class: "row g-3" }
const _hoisted_20 = { class: "col-4" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Giới tính", -1))
const _hoisted_22 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_23 = { class: "col-4" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngày sinh", -1))
const _hoisted_25 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_26 = { class: "col-4" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Nơi sinh", -1))
const _hoisted_28 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_29 = { class: "col-4" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Điện thoại", -1))
const _hoisted_31 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_32 = { class: "col-8" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Email", -1))
const _hoisted_34 = { class: "text-gray-900 fw-bolder fs-7 text-break" }
const _hoisted_35 = { class: "col-4" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "CMND/CCCD", -1))
const _hoisted_37 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_38 = { class: "col-4" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngày cấp", -1))
const _hoisted_40 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_41 = { class: "col-4" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "MST cá nhân", -1))
const _hoisted_43 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_44 = { class: "col-12" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Nơi cấp", -1))
const _hoisted_46 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_47 = { class: "col-4" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Dân tộc", -1))
const _hoisted_49 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_50 = { class: "col-4" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Tôn giáo", -1))
const _hoisted_52 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_53 = { class: "col-4" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Quốc tịch", -1))
const _hoisted_55 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_56 = { class: "col-12" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "TN THPT", -1))
const _hoisted_58 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_59 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary mb-3" }, "Địa chỉ", -1))
const _hoisted_61 = { class: "row g-3" }
const _hoisted_62 = { class: "col-4" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Hộ khẩu thường trú", -1))
const _hoisted_64 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_65 = { class: "col-4" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Phường/Xã", -1))
const _hoisted_67 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_68 = { class: "col-4" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Tỉnh/TP", -1))
const _hoisted_70 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_71 = { class: "col-4" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Địa chỉ liên lạc", -1))
const _hoisted_73 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_74 = { class: "col-4" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Phường/Xã", -1))
const _hoisted_76 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_77 = { class: "col-4" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Tỉnh/TP", -1))
const _hoisted_79 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_80 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary mb-3" }, "Thông tin học tập", -1))
const _hoisted_82 = {
  key: 0,
  class: "row g-3"
}
const _hoisted_83 = { class: "col-8" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Trường tốt nghiệp (CĐ/TC)", -1))
const _hoisted_85 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_86 = { class: "col-4" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Hình thức đào tạo", -1))
const _hoisted_88 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_89 = { class: "col-4" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Điểm TB (GPA)", -1))
const _hoisted_91 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_92 = { class: "col-4" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Số hiệu bằng", -1))
const _hoisted_94 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_95 = { class: "col-4" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Năm tốt nghiệp", -1))
const _hoisted_97 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_98 = { class: "col-4" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Ngày cấp bằng", -1))
const _hoisted_100 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_101 = {
  key: 0,
  class: "col-12"
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-info fs-8" }, "Tốt nghiệp CĐ theo hình thức liên thông từ Trung cấp", -1))
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = {
  key: 1,
  class: "row g-3"
}
const _hoisted_105 = { class: "col-6" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Trường lớp 10", -1))
const _hoisted_107 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_108 = { class: "col-6" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Trường lớp 11", -1))
const _hoisted_110 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_111 = { class: "col-6" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Trường lớp 12", -1))
const _hoisted_113 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_114 = { class: "col-6" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Năm tốt nghiệp", -1))
const _hoisted_116 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_117 = { class: "col-6" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Đối tượng ưu tiên", -1))
const _hoisted_119 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_120 = { class: "col-6" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Khu vực ưu tiên", -1))
const _hoisted_122 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_123 = { class: "col-6" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-600 fs-8" }, "Điểm ưu tiên", -1))
const _hoisted_125 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_126 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded p-4 mb-4"
}
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary mb-3" }, "Bảng điểm học bạ THPT", -1))
const _hoisted_128 = { class: "table table-row-dashed table-row-gray-200 align-middle gy-1 mb-0 umt-table" }
const _hoisted_129 = { class: "border-bottom border-gray-200" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Môn", -1))
const _hoisted_131 = { class: "text-gray-800 fs-7" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mt-2 fst-italic" }, "Chỉ hiện môn đã có điểm.", -1))
const _hoisted_133 = {
  key: 1,
  class: "text-muted fs-8"
}
const _hoisted_134 = {
  key: 2,
  class: "border border-gray-300 border-dashed rounded p-4 mb-4"
}
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-primary mb-3" }, "Điểm thi tốt nghiệp THPT", -1))
const _hoisted_136 = { class: "row g-2" }
const _hoisted_137 = { class: "d-flex align-items-center justify-content-between border border-gray-200 rounded px-2 py-1" }
const _hoisted_138 = { class: "text-gray-600 fs-8" }
const _hoisted_139 = { class: "text-gray-900 fw-bolder fs-7" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 mt-2 fst-italic" }, "Chỉ hiện môn đã có điểm.", -1))
const _hoisted_141 = {
  key: 1,
  class: "text-muted fs-8"
}
const _hoisted_142 = { class: "qd-sticky-bottom d-flex justify-content-end py-3 border-top border-gray-200" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-up-right ms-2 fs-8" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
    direction: "rtl",
    size: "500px",
    "with-header": false,
    "append-to-body": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Đang tải…"))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.d.fullName || 'Ứng viên'), 1),
                    (_ctx.d.studentcode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createTextVNode("MSSV: "),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.d.studentcode), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", {
                    class: "btn btn-sm btn-icon btn-active-light-primary flex-shrink-0",
                    title: "Đóng",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible = false))
                  }, [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                    ])
                  ])
                ]),
                (_ctx.admissionBadge || _ctx.enrollBadge || _ctx.d.orderNumber || _ctx.d.certificateNumber)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_ctx.admissionBadge)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(`badge badge-light-${_ctx.admissionBadge.state}`)
                          }, _toDisplayString(_ctx.admissionBadge.label), 3))
                        : _createCommentVNode("", true),
                      (_ctx.enrollBadge)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(`badge badge-light-${_ctx.enrollBadge.state}`)
                          }, _toDisplayString(_ctx.enrollBadge.label), 3))
                        : _createCommentVNode("", true),
                      (_ctx.d.orderNumber)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "SBD: " + _toDisplayString(_ctx.d.orderNumber), 1))
                        : _createCommentVNode("", true),
                      (_ctx.d.certificateNumber)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, "SHBTN: " + _toDisplayString(_ctx.d.certificateNumber), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.gradWarns.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createTextVNode(" " + _toDisplayString(_ctx.gradWarns.join(' · ')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.d.gender === true || _ctx.d.gender === 'true' ? 'Nam' : (_ctx.d.gender === false || _ctx.d.gender === 'false' ? 'Nữ' : '—')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.fmtDate(_ctx.d.dateOfBirth)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.d.birthPlace || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.d.phone || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.d.email || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.d.idCard || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.fmtDate(_ctx.d.dateOfIssue)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.d.taxNumber || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.d.issuePlace || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.d.ethnic || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.d.religion || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_53, [
                    _hoisted_54,
                    _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.d.nationality || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _hoisted_57,
                    _createElementVNode("div", _hoisted_58, _toDisplayString(({not_graduated:'Chưa tốt nghiệp', temp_graduated:'Giấy chứng nhận TNTT', graduated:'Đã tốt nghiệp'})[_ctx.d.highschoolGraduation] || '—'), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _hoisted_63,
                    _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.d.prAddress || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_65, [
                    _hoisted_66,
                    _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.d.newPrWardName || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _hoisted_69,
                    _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.d.newPrProvinceName || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _hoisted_72,
                    _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.d.contactAddress || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_74, [
                    _hoisted_75,
                    _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.d.newContactWardName || '—'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_77, [
                    _hoisted_78,
                    _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.d.newContactProvinceName || '—'), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _hoisted_81,
                (_ctx.isLt)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                      _createElementVNode("div", _hoisted_83, [
                        _hoisted_84,
                        _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.arpro.graduationschool || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_86, [
                        _hoisted_87,
                        _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.trainingFormLabel(_ctx.arpro.trainingform)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_89, [
                        _hoisted_90,
                        _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.arpro.gpa != null && _ctx.arpro.gpa !== '' ? `${_ctx.arpro.gpa}${_ctx.arpro.gpafor === 'gpa10' ? ' /10' : ' /4'}` : '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_92, [
                        _hoisted_93,
                        _createElementVNode("div", _hoisted_94, _toDisplayString(_ctx.arpro.graduationnumber || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_95, [
                        _hoisted_96,
                        _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.arpro.graduationyear || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _hoisted_99,
                        _createElementVNode("div", _hoisted_100, _toDisplayString(_ctx.fmtDate(_ctx.arpro.graduationday)), 1)
                      ]),
                      (_ctx.arpro.isintermediate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_101, _hoisted_103))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_104, [
                      _createElementVNode("div", _hoisted_105, [
                        _hoisted_106,
                        _createElementVNode("div", _hoisted_107, _toDisplayString(_ctx.joinParts([_ctx.d.class10SchoolName, _ctx.d.newClass10ProvinceName])), 1)
                      ]),
                      _createElementVNode("div", _hoisted_108, [
                        _hoisted_109,
                        _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.joinParts([_ctx.d.class11SchoolName, _ctx.d.newClass11ProvinceName])), 1)
                      ]),
                      _createElementVNode("div", _hoisted_111, [
                        _hoisted_112,
                        _createElementVNode("div", _hoisted_113, _toDisplayString(_ctx.joinParts([_ctx.d.class12SchoolName, _ctx.d.newClass12ProvinceName])), 1)
                      ]),
                      _createElementVNode("div", _hoisted_114, [
                        _hoisted_115,
                        _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.d.graduatedYear || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_117, [
                        _hoisted_118,
                        _createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.d.priorityObject || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_120, [
                        _hoisted_121,
                        _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.d.priorityArea || '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_123, [
                        _hoisted_124,
                        _createElementVNode("div", _hoisted_125, _toDisplayString(_ctx.d.priorityScore != null && _ctx.d.priorityScore !== '' ? _ctx.d.priorityScore : '—'), 1)
                      ])
                    ]))
              ]),
              (!_ctx.isLt)
                ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                    _hoisted_127,
                    (_ctx.scoredSubjects.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("table", _hoisted_128, [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", _hoisted_129, [
                                _hoisted_130,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcriptYears, (year) => {
                                  return (_openBlock(), _createElementBlock("th", {
                                    key: year.key,
                                    class: "text-center w-60px"
                                  }, _toDisplayString(year.label), 1))
                                }), 128))
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scoredSubjects, (sub) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: sub.value
                                }, [
                                  _createElementVNode("td", _hoisted_131, _toDisplayString(sub.label), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcriptYears, (year) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                      key: year.key,
                                      class: _normalizeClass(["text-center fs-7", _ctx.d.transcript?.[sub.value]?.[year.key] != null ? 'fw-bolder text-gray-900' : 'text-gray-400'])
                                    }, _toDisplayString(_ctx.d.transcript?.[sub.value]?.[year.key] ?? '—'), 3))
                                  }), 128))
                                ]))
                              }), 128))
                            ])
                          ]),
                          _hoisted_132
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_133, "Chưa nhập bảng điểm học bạ (nhập ở tab Thông tin học tập)."))
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.isLt)
                ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                    _hoisted_135,
                    (_ctx.scoredGradSubjects.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_136, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scoredGradSubjects, (sub) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "col-4",
                                key: sub.value
                              }, [
                                _createElementVNode("div", _hoisted_137, [
                                  _createElementVNode("span", _hoisted_138, _toDisplayString(sub.label), 1),
                                  _createElementVNode("span", _hoisted_139, _toDisplayString(_ctx.d.graduationscore[sub.value]), 1)
                                ])
                              ]))
                            }), 128))
                          ]),
                          _hoisted_140
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_141, "Chưa nhập điểm thi tốt nghiệp (nhập ở tab Thông tin học tập)."))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_142, [
                _createElementVNode("span", {
                  class: "btn btn-white btn-active-light-primary me-2 umt-btn-32",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = false))
                }, "Đóng"),
                (_ctx.d.id)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/danhsachungvien/${_ctx.d.id}${_ctx.detailQuery}`,
                      class: "btn btn-primary umt-btn-32"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Mở trang chi tiết "),
                        _hoisted_143
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ])
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}